<template>
    <div class="page-layout blank contacts-manage">
        <div class="d-flex align-items-center justify-content-center h-100" v-if="callInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div v-else class="pb-15 pr-3 pl-3">
            <div class="d-flex w-100 justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span @click="goBack()">Leads</span>
                    <a>View Lead</a>
                </div>
                <button class="btn btn-secondary btn-wide px-6" style="border-radius: 6px !important;" @click="cloneLead">
                    Edit
                </button>
            </div>
            <div class="d-flex">
                <div class="blue_header pointer" :class="{'activeColor':lead == false}" @click="selectTab('lead')">
                    <span>View Lead</span>
                </div>
                <div class="blue_header_triangle" :class="{'activeTab':lead == false}"></div>
                <div class="blue_header pointer" :class="{'activeColor':classification == false}" @click="selectTab('classification')">
                    <span>Classification</span>
                </div>
                <div class="blue_header_triangle" :class="{'activeTab':classification == false}"></div>
            </div>
            <div class="main-div" v-if="lead">
                <div class="header-outer">
                    <span class="fw-500">Lead Information</span>
                    <span class="pointer" @click="showHideLeadInformation">
                        <i v-if="leadInformationTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                        <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                    </span>
                </div>
                <div class="inner-div" v-if="leadInformationTab">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Title</span>
                                <div class="inputContainer">
                                    {{ leadData.title || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Lead Contact Name</span>
                                <div class="inputContainer">
                                    {{ leadData.lead_user_reference.name || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Lead Contact Number</span>
                                <div class="inputContainer">
                                    {{ leadData.lead_user_phone.phone_number || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Lead Contact Email</span>
                                <div class="inputContainer">
                                    {{ leadData.lead_user_email || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Lead Company Name</span>
                                <div class="inputContainer" v-if="leadData.lead_company">
                                    {{ leadData.lead_company.name || "-" }}
                                </div>
                                <div class="inputContainer" v-else>
                                    {{ '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Lead Source (Channel)</span>
                                <div class="inputContainer">
                                    {{ leadData.lead_source || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Campaign Source</span>
                                <div class="inputContainer">
                                    {{ leadData.campaign_source || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Lead Type</span>
                                <div class="inputContainer">
                                    {{ leadData.lead_status || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="d-flex">
                                <div class="infoHeader" style="width: 70%">
                                    <span class="fs-14 fw-600 text-secondary ml-2">Date</span>
                                    <div class="inputContainer">
                                        {{moment(leadData.lead_start_date).format("DD/MM/YYYY")}}
                                    </div>
                                </div>
                                <div style="width: 10%"></div>
                                <div class="infoHeader" style="width: 20%">
                                    <span class="fs-14 fw-600 text-secondary ml-2">Time</span>
                                    <div class="inputContainer" style="line-height: 1.2;">
                                        {{moment(leadData.lead_start_date).format('LT')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="leadData.lead_source == 'Conventional'" class="col-12 mt-8 header-inner">
                            <div class="d-flex align-items-center">
                                Conventional
                            </div>
                        </div>
                        <div v-if="leadData.lead_source == 'Conventional'" class="col-12">
                            <div class="row">
                                <div class="col-lg-8 col-md-8 col-sm-8 mt-2">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-2">
                                            <div class="infoHeader">
                                                <span class="fs-14 fw-600 text-secondary ml-2">Location Introduced</span>
                                                <div class="inputContainer">
                                                    <span v-if="leadData.location.street">{{ leadData.location.street }},</span>
                                                    <span v-if="leadData.location.city">{{ leadData.location.city }},</span>
                                                    <span v-if="leadData.location.state">{{ leadData.location.state }},</span>
                                                    <span v-if="leadData.location.country">{{ leadData.location.country }}</span>
                                                    <span v-if="leadData.location.street == '' && leadData.location.city == '' && leadData.location.state == '' && leadData.location.country == '' ">{{"-"}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-2">
                                            <div class="infoHeader">
                                                <span class="fs-14 fw-600 text-secondary ml-2">Lead Contact Via</span>
                                                <div class="inputContainer">
                                                    {{ leadData.lead_type || "-" }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-2">
                                            <div class="infoHeader">
                                                <span class="fs-14 fw-600 text-secondary ml-2">Referred By</span>
                                                <div class="inputContainer">
                                                    <span v-if="leadData.referred_by">
                                                        {{ leadData.referred_by.name || "-" }}
                                                    </span>
                                                    <span v-else>
                                                        {{"-"}}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-2">
                                            <div class="infoHeader">
                                                <span class="fs-14 fw-600 text-secondary ml-2">Meeting Type</span>
                                                <div class="inputContainer">
                                                    {{ leadData.meeting_type || "-" }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-4 mt-4">
                                    <div class="infoHeader">
                                        <span class="fs-14 fw-600 text-secondary ml-2">Secondary Attendees</span>
                                        <div class="inputContainer pt-2" style="min-height: 10.7em">
                                            <div style="padding-right: 10px; line-height: 1.5;" v-for="(secondary_attendee,index) in leadData.lead_secondary_attendees" :key="index">{{ secondary_attendee.name || "-" }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="leadData.lead_source == 'Social Media'" class="col-12 mt-8 header-inner">
                            <div class="d-flex align-items-center">
                                Social Media
                            </div>
                        </div>
                        <div v-if="leadData.lead_source == 'Social Media'" class="col-12">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                                    <div class="infoHeader">
                                        <span class="fs-14 fw-600 text-secondary ml-2">Social Media Type</span>
                                        <div class="inputContainer">
                                            {{ leadData.social_media[0].account_type || "-" }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 mt-2">
                                    <div class="infoHeader">
                                        <span class="fs-14 fw-600 text-secondary ml-2">Links/URL</span>
                                        <div class="inputContainer">
                                            <a :href="leadData.social_media[0].account_url" target="_blank" >{{ leadData.social_media[0].account_url || "-" }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="header-outer">
                    <span class="fw-500">Lead Company Data</span>
                    <span class="pointer" @click="showHideLeadCompanyData">
                        <i v-if="leadCompanyDataTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                        <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                    </span>
                </div>
                <div class="inner-div" v-if="leadCompanyDataTab">
                    <div class="row" v-for="(lead_target,index) in leadData.leads_target" :key="index">
                        <div class="col-12 mt-8 header-inner">
                            <div class="d-flex align-items-center">
                                Lead Target - {{ index+1 }}
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Fiscal Year</span>
                                <div class="inputContainer">
                                    {{ lead_target.fiscal_year || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Company Name</span>
                                <div class="inputContainer">
                                    {{ lead_target.lead_company.name || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Contact Name</span>
                                <div class="inputContainer">
                                    {{ lead_target.lead_user_reference.name || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Branch Name</span>
                                <div class="inputContainer">
                                    {{ lead_target.branch.name || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Department Name</span>
                                <div class="inputContainer">
                                    {{ lead_target.department || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Product Interest</span>
                                <div class="inputContainer">
                                    {{ lead_target.product.product_name || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="d-flex">
                                <div class="infoHeader" style="width: 70%">
                                    <span class="fs-14 fw-600 text-secondary ml-2">Transaction Closing Date</span>
                                    <div class="inputContainer">
                                        {{moment(lead_target.transaction_end_date).format("DD/MM/YYYY")}}
                                    </div>
                                </div>
                                <div style="width: 10%"></div>
                                <div class="infoHeader" style="width: 20%">
                                    <span class="fs-14 fw-600 text-secondary ml-2">Time</span>
                                    <div class="inputContainer" style="line-height: 1.2;">
                                        {{moment(lead_target.transaction_end_date).format('LT')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Unit of Measure</span>
                                <div class="inputContainer">
                                    {{ lead_target.uom || "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Transaction Value</span>
                                <div class="d-flex">
                                    <div class="inputContainer text-center p-0" style="width: 8%">
                                        {{ lead_target.transaction_value.symbol || "-" }}
                                    </div>
                                    <div style="width: 2%"></div>
                                    <div class="inputContainer" style="width: 90%">
                                        {{ lead_target.transaction_value.value || "-" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Links/URL</span>
                                <div class="inputContainer mb-2" v-for="(link,index) in lead_target.company_links" :key="index">
                                   <span> <a :href="link" target="_blank">{{  link || "-" }}</a></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 table-responsive mt-6 w-100" style="overflow-x:auto;">
                            <table class="table-leads-target w-100">
                                <thead>
                                    <tr style="background-color: #00448b;">
                                        <th style="border-top-left-radius: 5px;">Month</th>
                                        <th>Jan</th>
                                        <th>Feb</th>
                                        <th>Mar</th>
                                        <th>Apr</th>
                                        <th>May</th>
                                        <th>June</th>
                                        <th>July</th>
                                        <th>Aug</th>
                                        <th>Sep</th>
                                        <th>Oct</th>
                                        <th>Nov</th>
                                        <th>Dec</th>
                                        <th style="border-top-right-radius: 5px;">Transaction <br> Target</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="units">
                                        <td class="fw-600">Units</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.jan }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.feb }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.mar }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.apr }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.may }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.jun }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.jul }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.aug }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.sept }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.oct }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.nov }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.dec }}</td>
                                        <td v-if="lead_target.target" style="background-color:#dfe8f4">{{lead_target.target.jan + lead_target.target.feb + lead_target.target.mar + lead_target.target.apr + lead_target.target.may + lead_target.target.jun + lead_target.target.jul + lead_target.target.aug + lead_target.target.sept + lead_target.target.oct + lead_target.target.nov + lead_target.target.dec }}</td>
                                    </tr>
                                    <tr class="units">
                                        <td class="fw-600" style="border-bottom-left-radius: 5px;">Value($)</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.jan_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.feb_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.mar_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.apr_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.may_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.jun_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.jul_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.aug_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.sept_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.oct_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.nov_quantity }}</td>
                                        <td v-if="lead_target.target">{{ lead_target.target.dec_quantity }}</td>
                                        <td v-if="lead_target.target" style="background-color:#dfe8f4">{{lead_target.target.jan_quantity + lead_target.target.feb_quantity + lead_target.target.mar_quantity + lead_target.target.apr_quantity + lead_target.target.may_quantity + lead_target.target.jun_quantity + lead_target.target.jul_quantity + lead_target.target.aug_quantity + lead_target.target.sept_quantity + lead_target.target.oct_quantity + lead_target.target.nov_quantity + lead_target.target.dec_quantity }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 mt-8">
                            <div class="header-inner">
                                <div class="d-flex align-items-center">
                                    Connect Call Reports
                                </div>
                            </div>
                            <div class="infoHeader mt-4">
                                <div class="inputContainer" style="height: 15em;">
                                    <div class="callreports">
                                        <span class="call-report-number" v-for="call_report in leadData.lead_call_reports" :key="call_report._id">{{ call_report.call_report_number || "-" }}</span>
                                    </div>
                                    <span v-if="leadData.lead_call_reports.length == 0" class="d-flex justify-content-center flex-column align-items-center fw-500" style="color: rgba(103, 103, 103, 0.84);">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/call_report_new.svg">
                                        There are no Call Reports found!
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 mt-8">
                            <div class="header-inner">
                                <div class="d-flex align-items-center">
                                    Reminders
                                </div>
                            </div>
                            <div class="infoHeader mt-4">
                                <div class="inputContainer p-2" style="height: 15em;">
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <span v-if="leadData.lead_reminders.length == 0" class="d-flex justify-content-center flex-column align-items-center fw-500" style="color: rgba(103, 103, 103, 0.84);">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reminder_new.svg">
                                                You don't add any Reminders yet!
                                            </span>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6" v-for="(reminder,index) in leadData.lead_reminders" :key="index">
                                            <div class="reminders">
                                                <div class="calendar">
                                                    <span>{{moment(reminder.event_schedule.start_date).format("MM")}}</span>
                                                    <span class="fw-600 fs-18">{{moment(reminder.event_schedule.start_date).format("DD")}}</span>
                                                    <span>{{ moment(reminder.event_schedule.start_date).format("YYYY") }}</span>
                                                </div>
                                                <div class="d-flex flex-column ml-2">
                                                    <span class="fw-600">{{ reminder.name || '-'}}</span>
                                                    <span class="fw-600" style="color: #939393; font-size: 10px">{{ moment(reminder.event_schedule.start_date).format("HH:MM") }} {{ reminder.event_schedule.ampm }}, {{ reminder.event_schedule.day }}</span>
                                                    <span style="color: #939393; font-size: 8px">{{ reminder.number }} {{ reminder.gap }} to Go!</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="header-outer">
                    <span class="fw-500">Attachments</span>
                    <span class="pointer" @click="showHideAttachments">
                        <i v-if="attachmentsTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                        <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                    </span>
                </div>
                <div class="inner-div" v-if="attachmentsTab">
                    <div v-if="audiovideo.length == 0 && files.length == 0 && images.length == 0" class="d-flex justify-content-center w-100 fw-600 fs-16">
                        No Attachments
                    </div>
                    <div v-if="files.length && attachmentsTab" class="files-attachments">
                        <span class="d-flex justify-content-center text-white fw-600 fs-14 py-4" style="border-top-left-radius: 12px; border-top-right-radius: 12px; background: #00448b;">FILES</span>
                        <div class="_files" v-for="(file,index) in files" :key="index">
                            <div class="d-flex justify-content-between w-100">
                                <div>
                                    <img
                                        v-if="file.name.endsWith('.pdf')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg"
                                    />
                                    <img
                                        v-else-if="file.name.endsWith('.png')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg"
                                    />
                                    <img
                                        v-else-if="file.name.endsWith('.jpg')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg"
                                    />
                                    <img
                                        v-else-if="file.name.endsWith('.svg')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg"
                                    />
                                    <img
                                        v-else-if="file.name.endsWith('.xls') || file.name.endsWith('.xlsx')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg"
                                    />
                                    <img
                                        v-else-if="file.name.endsWith('.doc') || file.name.endsWith('.docx')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg"
                                    />
                                    <span class="ml-2 fw-600 text-dark fs-14">
                                        {{ file.name }} <span class="ml-3" style="color:#808495">({{ file.size }})</span>
                                    </span>
                                </div>
                                <div>
                                    <a :href="file.url" download style="text-decoration: none;">
                                        <i class="icon icon-download"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="images.length && attachmentsTab" class="files-attachments mt-5">
                        <span class="d-flex justify-content-center text-white fw-600 fs-14 py-4" style="border-top-left-radius: 12px; border-top-right-radius: 12px; background: #00448b;">IMAGES</span>
                        <div class="report-images">
                            <div v-for="(image,index) in images" :key="index">
                                <span class="_images pointer" style="position: relative;" @click="previewImage(image)">
                                    <a class="mr-3 pointer img_more" :href="image.url" download>
                                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/download_img.svg" alt="" style="width:15px">
                                    </a>
                                    <img :src="image.url" alt="">
                                    <span>{{ image.name }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="audiovideo.length && attachmentsTab" class="files-attachments mt-5">
                        <span class="d-flex justify-content-center text-white fw-600 fs-14 py-4" style="border-top-left-radius: 12px; border-top-right-radius: 12px; background: #00448b;">AUDIOS / VIDEOS</span>
                            <div class="report-images">
                            <div class="_images" style="position: relative;" v-for="(audiovid,index) in audiovideo" :key="index">
                                <a class="mr-3 pointer img_more" :href="audiovid.url" download>
                                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/download_img.svg" alt="" style="width:15px">
                                </a>
                                <video controls>
                                    <source :src="audiovid.url" type="video/*">
                                </video>
                                <span>{{ audiovid.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex w-100 justify-content-center align-items-center">
                    <button class="btn btn-des-small" style="color: rgb(255, 255, 255); background-color: rgb(213, 22, 80);" @click="goBack()">Close</button>
                </div>
            </div>
            <div v-else class="main-div">
                <div class="header-outer py-1">
                    <span class="fw-500">Classification Information</span>
                </div>
                <div class="inner-div">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Status</span>
                                <div class="inputContainer" v-if="leadData.classification">
                                    {{leadData.classification.status}}
                                </div>
                                <div class="inputContainer" v-else>
                                    -
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Classification</span>
                                <div class="inputContainer" v-if="leadData.classification">
                                    {{leadData.classification.classification}}
                                </div>
                                <div class="inputContainer" v-else>
                                    -
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                            <div class="infoHeader">
                                <span class="fs-14 fw-600 text-secondary ml-2">Sales Person</span>
                                <div class="inputContainer" v-if="leadData.classification.sales_person">
                                    <span>{{leadData.classification.sales_person.name}}</span>
                                </div>
                                <div class="inputContainer" v-else>
                                    -
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex w-100 justify-content-center align-items-center">
                    <button class="btn btn-des-small" style="color: rgb(255, 255, 255); background-color: rgb(213, 22, 80);" @click="goBack()">Close</button>
                </div>
            </div>
        </div>
        <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
    </div>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import moment from "moment";
var mime = require('mime-types')
const Preview = () => import("./Preview");
const { uuid } = require('uuidv4');
export default {
    data() {
        return {
            callInProgress: false,
            leadInformationTab: true,
            leadCompanyDataTab: true,
            attachmentsTab: true,
            files: [],
            images: [],
            audiovideo: [],
            leadData: "",
            lead:true,
            classification:false,
            dialogImageUrl: '',
            dialogVisible: false,
            preview_file: '',
            preview_visible: false
        }
    },
    components: {
        HalfCircleSpinner,
        Preview
    },
    methods: {
        hidePreview(){
            this.preview_visible = false
        },
        previewImage(file) {
            let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            file['content_type'] = content_type;
            this.preview_file = file;
            this.preview_visible = true;
        },
        selectTab(obj){
            if(obj == 'lead'){
                this.lead = true
                this.classification = false
            }else if(obj == 'classification'){
                this.lead = false
                this.classification = true
            }
        },
        moment(date) {
            return moment(date);
        },
        showHideLeadInformation() {
            if (this.leadInformationTab) {
                this.leadInformationTab = false;
            } else {
                this.leadInformationTab = true;
            }
        },
        showHideLeadCompanyData() {
            if (this.leadCompanyDataTab) {
                this.leadCompanyDataTab = false;
            } else {
                this.leadCompanyDataTab = true;
            }
        },
        showHideAttachments() {
            if (this.attachmentsTab) {
                this.attachmentsTab = false;
            } else {
                this.attachmentsTab = true;
            }
        },
        cloneLead() {
            localStorage.setItem("clone", this.leadData._id);
            this.$router.push("/createLeads");
        },
        goBack(){
            this.$router.push("/listleads");
        },
        async getLeadData() {
            this.callInProgress = true;
            let res = await this.$http.get("/leads/get?id=" + this.$route.params.id);
            if (res.data.status_id == 1) {
                this.leadData = res.data.response;
                this.leadData.attachments.forEach(x => {
                    let type = x.name.split(".");
                    if (type[1] == "jpg" || type[1] == "jpeg" || type[1] == "png" || type[1] == "svg") {
                        this.images.push(x);
                    }else if (type[1] == "doc" || type[1] == "docx" || type[1] == "xlsx" || type[1] == "xls" || type[1] == "pdf") {
                        this.files.push(x);
                    } else {
                        this.audiovideo.push(x);
                    }
                    if ("event_schedule" == x.lead_reminders) {
                        if (x.lead_reminders.event_schedule.start_date){
                            let startDate = x.lead_reminders.event_schedule.start_date;
                            let pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                            let formattedDate = new Date(startDate.replace(pattern,'$3-$2-$1'));
                            let date = startDate.split("/");
                            let time = x.lead_reminders.event_schedule.start_date.split(":");
                            Object.assign(x.lead_reminders.event_schedule.start_date, {
                                month: formattedDate.toLocaleString('default', { month: 'short' }),
                                dateNum: date[0],
                                day: formattedDate.toLocaleString('default', { weekday: 'long' }),
                                ampm: time[0] >= 12 ? "pm" : "am",
                            });
                        }
                    }
                });
                this.callInProgress = false;
            }
        }
    },
    created() {
        this.getLeadData();
    }
}
</script>

<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .header-outer {
        width: 100%;
        background: #005dae;
        color: #fff;
        font-size: 14px;
        padding-top: 2px;
        padding-bottom: 2px;
        margin-bottom: 10px;
        padding-right: 20px;
        padding-left: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .header-inner {
        background: #00448b;
        color: #fff;
        padding-top: 4px;
        padding-bottom: 4px;
        margin-bottom: 10px;
        padding-right: 20px;
        padding-left: 20px;
        font-weight: 500;
        font-size: 14px;
    }
    .inner-div {
        padding-top: 10px;
        padding-bottom: 40px;
        padding-left: 80px;
        padding-right: 80px;
    }
    .inputContainer {
        color: #303031;
        font-size: 12px;
        padding-left: 10px;
        padding-right: 10px;
        box-shadow: 0 0 3px 0 #3f3f3f;
        border-radius: 5px;
    }
    .table.table-leads-target {
        border-radius: 5px;
    }
    .table-leads-target {
        border: solid 1px #707070;
    }
    .table-leads-target td,
    .table-leads-target th {
        border: 1px solid #707070;
    }
    .table-leads-target thead th {
        color: #fff;
        text-align: center;
    }
    .table-leads-target tbody td {
        text-align: center;
    }
    .table-leads-target tbody td,
    .table-leads-target thead th {
        border-bottom-width: 0px;
        white-space: nowrap;
        height: 4em;
    }
    .table.table-leads-target thead th {
        border-bottom: 0px solid #707070 !important;
        font-weight: bold;
        font-size: 14px !important;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #fff !important;
        text-transform: none !important;
        vertical-align: middle;
        text-align: center;
    }
    .table.table-leads-target tbody td {
        padding: 0 !important;
        color: #303031;
        font-size: 13px;
    }
    .reminders {
        box-shadow: 0 0 3px 0 #939393;
        padding: 5px;
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        line-height: 20px;
    }
    .calendar {
        border-radius: 5px;
        background: #00448b;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 5em;
        width: 5em;
        font-size: 12px;
    }
    .calendar > span {
        color: #fff;
    }
    .callreports {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
    .call-report-number {
        border-radius: 20px;
        background: #00448b;
        color: #fff;
        font-size: 12px;
        padding: 2px 4px 2px 4px;
        margin: 4px;
        line-height: 20px;
    }
    .files-attachments{
        /* padding: 0 0 4.5px; */
        border-radius: 6px;
        border: solid 0.5px #707070;
        background-color: #ffffff;
    }
    .title_files{
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        color: #ffffff;
        background-color: #00448b;
        padding: 5px;
        display: flex;
        justify-content: end;
    }
    .file-text{
        text-align: center;
        font-size: 14px;
        font-weight: 600;
    }
    .file-arrow{
        font-weight: 600;
    }
    ._files{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0px 7px 7px 7px;
        background-color: #f1f3f4;
        border-radius: 4px;
        padding: 8px;
    }
    .report-images{
        display: flex;
        flex-direction: row;
        flex-flow: wrap;
    }
    ._images{
        margin: 5px;
        padding: 5px;
        border-radius: 2.5px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.2);
        background-color: #f6f8ff;
        width: 180px !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    ._images > img{
        width: 170px !important;
        height: 100px !important;
    }
    ._images > video{
        width: 170px !important;
        height: 100px !important;
    }
    ._images > span {
        font-size: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        padding-top: 5px;
    }
    .activeColor{
        background-color: #f2f3f5 !important;
        color: #707070;
    }
    .activeTab{
		width: 0;
		height: 0;
		border-bottom: 40px solid #f2f3f5;
		border-right: 25px solid transparent;
		margin-top: 7px;
		margin-left: -2px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ViewLead.vue